

export class EmployeeAgreementBO {
  id: string = "00000000-0000-0000-0000-000000000000";
  backgroundStudyAuthorization: BackgroundStudyAuthorizationBO =
    new BackgroundStudyAuthorizationBO();
  employeeAgreementAndDirectDeposit: EmployeeAgreementAndDirectDepositBO =
    new EmployeeAgreementAndDirectDepositBO();
  employeeApplicationCover: EmployeeApplicationCoverBO =
    new EmployeeApplicationCoverBO();
  employeesWithholdingCertificate: EmployeesWithholdingCertificateBO =
    new EmployeesWithholdingCertificateBO();
  employmentEligibilityVerification: EmploymentEligibilityVerificationBO =
    new EmploymentEligibilityVerificationBO();
  individualDirectSupportWorkerEnrollmentApplication: IndividualDirectSupportWorkerEnrollmentApplicationBO =
    new IndividualDirectSupportWorkerEnrollmentApplicationBO();
  individualSupportWorkerProviderAgreement: IndividualSupportWorkerProviderAgreementBO =
    new IndividualSupportWorkerProviderAgreementBO();
  payNotice: PayNoticeBO = new PayNoticeBO();
  relationshipDisclosure: RelationshipDisclosureBO =
    new RelationshipDisclosureBO();
  w4MinnesotaWithholdingAllowanceOrExemptionCertificate: W4MinnesotaWithholdingAllowanceOrExemptionCertificateBO =
    new W4MinnesotaWithholdingAllowanceOrExemptionCertificateBO();
  w4MNInstructionsForEmployeesAndPensionOrAnnuityRecipients: W4MNInstructionsForEmployeesAndPensionOrAnnuityRecipientsBO =
    new W4MNInstructionsForEmployeesAndPensionOrAnnuityRecipientsBO();
  isCompleted: boolean;
  employeeStatusLid: string;
  clientStatusLid: string;
  employeeId: string;
  clientId: string;
}

export class EmployeeApplicationCoverBO {
  employeeName: string;
  agencyName: string;
  agencyId: string;
}

export class BackgroundStudyAuthorizationBO {
  firstName: string;
  middleName: string;
  lastName: string;
  ssn: string;
  dob: string;
  driver_LicenseNo: string;
  state: string;
  placeofBirth: string;
  address: string;
  city: string;
  state1: string;
  zip: string;
  county: string;
  phone: string;
  email: string;
  agencyName: string;
  participantName: string;
  previousNamesUsed1: string;
  previousNamesUsed2: string;
  previousNamesUsedDate1: string | null;
  previousNamesUsedDate2: string | null;
  previous_Addresses_Used1: string;
  previous_Addresses_Used2: string;
  previous_Addresses_Used3: string;
  previous_Addresses_UsedDate1: string | null;
  previous_Addresses_UsedDate2: string | null;
  previous_Addresses_UsedDate3: string | null;
  applicantSignature: string;
  applicantSignatureDate: string | null;
  parentSignature: string;
  parentSignatureDate: string | null;
  genderLid: string;
  agencyId: string;
  genderName: string;
}

export class PayNoticeBO {
  effectiveDate: string;
  service: string;
  rate: number;
  employeeSign: string;
  employerSign: string;
  employeeName: string;
  employerName: string;
  agencyName: string;
  employeeSignDate: string | null;
  employerSignDate: string | null;
  agencyId: string;
  payNoticePayrateDetails: PayNoticePayrateDetailBO[];
}

export class PayNoticePayrateDetailBO {
  id: string = "00000000-0000-0000-0000-000000000000";
  effectiveDate: string;
  service: string;
  rate: number;
  payNoticeId: string;
  agencyId: string;
}

export class RelationshipDisclosureTaxDetailBO {
  id: string = "00000000-0000-0000-0000-000000000000";
  taxName: string;
  taxable: boolean;
  relationshipDisclosureId: string;
}

export class RelationshipDisclosureBO {
  agencyName: string;
  employeeName: string;
  employerName: string;
  relationshipName: string;
  applicantSign: string;
  applicantSignDate: string | null;
  employersSign: string;
  employersSignDate: string | null;
  dob: string | null;
  employerandWantWorkers: boolean;
  relationshipDisclosureTaxDetails: RelationshipDisclosureTaxDetailBO[];
}

export class W4MinnesotaWithholdingAllowanceOrExemptionCertificateBO {
  firstName: string;
  lastName: string;
  middleInitial: string;
  socialSecurityNumber: string;
  maritalStatus: string;
  determine_minnesota_allowances: string;
  ifNoOneClaimyouasdependent: string;
  ifanyofFollowingApply: string;
  haveeitherworkingSpouseormorethanOneJob: string;
  filingstatusHeadofHousehold: string;
  deductionsandAdditionalIncomeWorksheet: string;
  minnesotaAllwances: string;
  additionalMinnesotawithholding: string;
  numberofdependents: string;
  exemption_minnesota_withholdingsec2: string;
  state_domicile: string;
  reservation_name: string;
  enroll_no: string;
  signature: string;
  date: string | null;
  phoneNumber: string;
  nameofEmployer: string;
  taxIdNumber: string;
  federal_Id_number: string;
  employerAddress: string;
  employerCity: string;
  employerState: string;
  employerZip: string;
  address: string;
  city: string;
  state: string;
  zip: string;
}

export class IndividualSupportWorkerProviderAgreementBO {
  
  directSupportWorkerInitial: string;
  umpi: string;
  signDeclaration: boolean;
  title: string;
  sign: string;
  signDate: string | null;
  agencyName: string;
  nameofSupportWorkerName: string;
  nameofSupportWorkerNamePrint: string;
}

export class W4MNInstructionsForEmployeesAndPensionOrAnnuityRecipientsBO {
  estimate_Minnesota_ItemizedDeductions: number | null;
  enterBasedOnFillingStatus: number | null;
  subtractStep2FromStep1: number | null;
  estimate_AdditionalStandardDeductions: number | null;
  addStep3AndStep4: number | null;
  estimateTaxableNonwageIncome: number | null;
  subtractStep6FromStep5: number | null;
  divideAmountOnStep7bySomeAmt: number | null;
  numberStepF: number | null;
  addStep8andStep9: number | null;
  agencyName: string;
}

export class IndividualDirectSupportWorkerEnrollmentApplicationBO {
  agencyName:string;
  ssn: string;
  npiOrUmpi: string;
  firstName: string;
  lastName: string;
  middleName: string;
  dob: string | null;
  phone: string;
  street: string;
  city: string;
  state: string;
  zip: string;
  county: string;
  nameIndividualSupportWorker: string;
  sign: string;
  signDate: string | null;
  providerType: string;
  programType: string;
  organizationName: string;
  signelectronically: boolean;
  newHireOrReHire: string;
  previousEmployementEndDate: string | null;
  isMcoClaimsOnly: boolean;
  individualDswBackgroundStudyInfo: string | null;
  isQualifiedEnhancedRateTraining: boolean;
  optionalTrainingCompletionDate: string | null;
  optionalTrainingExpirationDate: string | null;
  isAffiliateIndividualDsw: boolean;
  orgAffiliationInfoSignDeclaration: boolean;
  facilityNpi: string;
  studyId: string;
  orgPersonalCompletingForm: string;
  orgPersonalSign: string;
  orgPersonalFax: string;
  dswBackgroundStudyInfoForms: DswBackgroundStudyInfoFormBO[];
}

export class DswBackgroundStudyInfoFormBO {
  id: string = "00000000-0000-0000-0000-000000000000";
  bsgNumber: string;
  applicationNumber: string;
  facilityId: string;
  individualDirectSupportWorkerEnrollmentApplicationId: string;
}

export class EmployeeAgreementAndDirectDepositBO {
  routing: string;
  account: string;
  checkingOrSaving: string;
  applicant_name: string;
  employee_sign: string;
  agencyName: string;
}

export class EmploymentEligibilityVerificationBO {
  firstName: string;
  lastName: string;
  middleName: string;
  otherLastNameUsed: string;
  address: string;
  apt: string;
  city: string;
  state: string;
  dob: string | null;//
  us_Ssn: string;
  zipcode: string;
  employees_Email: string;
  employeesPhone: string;
  alien_Registration_Number: string;
  alien_Registration_ExpiryDate: string | null;//
  alien_Registration_Number_Uscis_Number: string;
  form_I_94Admission_Number: string;
  foreign_Passport_Number: string;
  countryofIssuance: string;
  signOfEmployee: string;
  todaysDate: string | null;///
  employeesFirstdayEmployment: string | null;//
  employerSign: string;
  employerSignDate: string | null;
  employerFirstName: string;
  employerLastName: string;
  employersOrgName: string;
  employersAddress: string;
  employersCity: string;
  employersState: string;
  employersZip: string;
  reverificationFirstName: string;
  reverificationLastName: string;
  reverificationMiddleName: string;
  reverificationDate: string | null;//
  employerDocumentTitle: string;
  documentNum: string;
  documentExpiryDate: string | null;//
  penaltyOfPerjury: string;
  employerSign1: string;
  nameofEmployer: string;
  employerSignDate1: string | null;
  employeeSection2FirstName: string;
  employeeSection2LastName: string;
  employeeSection2MiddleName: string;
  employeeSection2citizenship: string;
  did_not_use_preparerortranslator: string;
  preparerorTraslatorAssisted: string;
  signOfPreparerorTraslator: string;
  signOfPreparerorTraslatorDate: string | null;//
  preparerFirstName: string;
  preparerLastName: string;
  preparerCity: string;
  preparerState: string;
  preparerAddress: string;
  preparerZip: string;
  documentTitle: string;
  issuingAuthority: string;
  documentNumber: string;
  expirationDate: string | null;
  documentTitle1: string;
  issuingAuthority1: string;
  documentNumber1: string;
  expirationDate1: string | null;
  documentTitle2: string;
  issuingAuthority2: string;
  documentNumber2: string;
  expirationDate2: string | null;
  documentTitle3: string;
  issuingAuthority3: string;
  documentNumber3: string;
  expirationDate3: string | null;
  documentTitle4: string;
  issuingAuthority4: string;
  documentNumber4: string;
  expirationDate4: string | null;
  additionalInfo: string;
  employerTitle: string | null;
  employerSignDate3:string | null;
}

export class EmployeesWithholdingCertificateBO {
  firstName: string;
  lastName: string;
  middleName: string;
  maritialStatus: string;
  social_Security_Number: string;
  multipleJobsOrSpouseWorkSectionc: boolean =false;
  employeeSignature: string;
  employeeName: string;
  signDate: string | null;
  firstDateOfEmployeement: string | null;
  identificationNumber: string;
  agencyName: string;
  qualifyingChildrenUnder_AgeSeventeen: number | null;
  otherDependents: number | null;
  total: number | null;
  otherIncome: number | null;
  deductions: number | null;
  additionalTax: number | null;
  otherAdjustmentTotal: number | null;
  multiJobsWorksheetFirstJobField: string;
  multiJobsWorksheetSecondjobField_a: string;
  multiJobsWorksheetSecondjobField_b: string;
  multiJobsWorksheetSecondjobField_c: string;
  multiJobsWorksheetThirdHobField: string;
  multiJobsWorksheetTourthJobField: string;
  deductionfirstamout: number | null;
  deductionSecondamount: number | null;
  deductionThirdamount: number | null;
  deductionFourthamount: number | null;
  deductionFifthamount: number | null;
  address: string;
  city: string;
  state: string;
  zip: string;
}



export class GetListBO {
  spendownfilter: boolean;
  ptype: string | null;
  role: string;
  user: string | null;
  menuID: string | null;
  parentMenuID: string | null;
  searchColumn: string;
  searchText: string;
  stage: string;
  listId: string | null;
  groupId: string | null;
  lovCode: string;
  userId: string | null;
  agencyId: string | null;
  isEvv: boolean;
  formtype: string;
  formuserId: string;
  employeeId: string;
  clientId: string;
  locationId: string | null;
  supervisorId: string;
  statusLid: string;
  contactTypeLid: string;
  relationshipLid: string;
  onboardLid: string;
  typefor: string;
  requestStatusLid: string | null;
  vendorId: string | null;
  submittedDate: string | null;
  startDate: string | null;
  endDate: string | null;
  currentpageno: number;
  pageitem: number;
  orderColumn: string;
  orderType: string;
  type: string;
  field: string;
  operator: string;
  value: string;
  matchCase: boolean;
}
export class EmployeeBO {
  id: string;
  firstName: string;
  middleName: string;
  lastName: string;
  name: string;
  gender_Name: string;
  username: string;
  sSNlast4digits: string;
  employeeTypeLidName: string;
  locationName: string;
  statusLidName: string;
  age: number;
  dOB: string;
  apt: string;
  street: string;
  city: string;
  steet: string;
  zipcode: string;
  county: string;
  phone1: string;
  phone2: string;
  email: string;
  uMPI: string;
  sSN: string;
  pCACertificateNumber: string;
  aKA: string;
  rNNPI: string;
  requiredEVV: boolean | null;
  isEligibleForManualETimeSheet: boolean;
  hiredate: string | null;
  inactivedate: string | null;
  terminationdate: string | null;
  pEmployeeId: number | null;
  officeStaff: boolean;
  employeeTypeLid: string | null;
  genderLid: string;
  languageLid: string[];
  language: string[];
  driverLicense: string;
  placeofBirth: string;
  locationId: string;
  maritalStatusLid: string | null;
  statusLid: string;
  agencyId: string;
  loginUserId: string | null;
  agencyName: string;
}

export class SubmitEmployeeAggremntBo {
  type:string;
  aggrementId: string;
  employeeStatusLid: string;
}